import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'

type InvitationRequest = paths['/api/carts/multi-carts/{multiCartId}/users/invite']['post']['parameters']['body']['payload']
type InvitationResponse = paths['/api/carts/multi-carts/{multiCartId}/users/invite']['post']['responses']['201']['content']['application/json']
export type MultiCartInvitationUsers = paths['/api/carts/multi-carts/{multiCartId}/users/invite']['post']['parameters']['body']['payload']['users']

export function inviteUsersToMultiCart(cartId: string, users: MultiCartInvitationUsers) {
  return request.post<InvitationResponse, InvitationRequest>(`/api/carts/multi-carts/${cartId}/users/invite`, { users }, { credentials: 'include' })
}
